import { render, staticRenderFns } from "./TipoContactoModalNuevo.vue?vue&type=template&id=2e655c46&scoped=true&"
import script from "./TipoContactoModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./TipoContactoModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./TipoContactoModalNuevo.vue?vue&type=style&index=0&id=2e655c46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e655c46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2e655c46', component.options)
    } else {
      api.reload('2e655c46', component.options)
    }
    module.hot.accept("./TipoContactoModalNuevo.vue?vue&type=template&id=2e655c46&scoped=true&", function () {
      api.rerender('2e655c46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TipoContacto/TipoContactoModalNuevo.vue"
export default component.exports